import request from '@/utils/request'
import { wisdomsitePrefix } from './config'

export function projectCompanyData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/companyByProject',
    method: 'post',
    data
  })
}
export function teamByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/teamByProject',
    method: 'post',
    data
  })
}
export function projectDataCount(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/projectDataCount',
    method: 'post',
    data
  })
}
export function projectDeviceData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/projectDeviceData',
    method: 'post',
    data
  })
}
export function projectManagerData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/projectManagerData',
    method: 'post',
    data
  })
}
export function querySiteProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProject/queryByProject',
    method: 'post',
    data
  })
}
export function siteStatisticsPersonCount(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/personCount',
    method: 'post',
    data
  })
}
export function monthDeviceCountIn(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/monthDeviceCountIn',
    method: 'post',
    data
  })
}
export function monthAttendanceStatistics(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/monthAttendanceStatistics',
    method: 'post',
    data
  })
}
export function personDataRate(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/personDataRate',
    method: 'post',
    data
  })
}
export function deviceOnlineRate(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteStatistics/deviceOnlineRate',
    method: 'post',
    data
  })
}
